var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkedin = function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F9F9F9",
    d: "M13.4 13.4V8.712c0-2.304-.495-4.064-3.183-4.064-1.296 0-2.16.704-2.512 1.376h-.032V4.856H5.129V13.4h2.656V9.16c0-1.12.208-2.192 1.584-2.192 1.36 0 1.376 1.264 1.376 2.256v4.16H13.4zM.809 4.86h2.656v8.543H.809zM2.138.602C1.29.602.602 1.29.602 2.138A1.55 1.55 0 0 0 2.138 3.69a1.55 1.55 0 0 0 1.536-1.552c0-.848-.688-1.536-1.536-1.536"
  })));
};
export default SvgLinkedin;